export default __webpack_public_path__ + "static/media/check-active.2b7eb655.png";